import Vue from "vue";

const RecipientService = {
    base_api() {
        let base = process.env.VUE_APP_CWM_API_URL || "https://www.warmuseum.ca/_api";
        return base;

    },
    /**
     * Retrieve all of Recipients
     * @param {*} lang The language, either `en` or `fr`
     */
    all(lang) {
        return Vue.axios.get(`${this.base_api()}/${lang}/medals/_list/all`)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Retrieve a Recipient detail
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} slug
     */
    detail(lang, slug) {
        return Vue.axios.get(`${this.base_api()}/${lang}/medals/person/${slug}`)
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    },

    /**
     * Search a Recipient field by the provided token
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} field
     * @param {*} token
     */
    search(lang, field, token) {

        //When you wrap the contains value (token) with quotes, the search engine will return matched phrases
        //instead of finding individual words in the entire list of medals
        token = '"' + token + '"';
        var endpoint = `${this.base_api()}/_search/${lang}/medals/person/${field}/_contains/${encodeURI(token)}`;

        return Vue.axios.get(endpoint, {
            params: {
                sort: 'NamLast',
                size: 500
            }
         })
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
             });

    },

// -- Convenience Methods

    /**
     * Convenience method to retrieve recipients by medal name
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} medal Full name from the `name` field of the medal
     */
    medal_recipients(lang, medal) {

        let specialMedals = ['Memorial Cross', 'Memorial Plaque'];

        if (specialMedals.includes(medal)) {
            return this.search(lang, 'search.ObjDisplayName', medal);
        } else {
            return this.search(lang, 'search.DesObjCompNames', medal)
        }
    }
};

export default RecipientService;
